import "./sidebar.css";
import { ReactComponent as DashboardSvg } from "src/Assets/icons/dashboard.svg";
// import { ReactComponent as FavoriteSvg } from "src/Assets/icons/favorite.svg";
import { ReactComponent as LogoutSvg } from "src/Assets/icons/logout.svg";
// import { ReactComponent as ProfileSvg } from "src/Assets/icons/profile.svg";
import { ReactComponent as ReservationSvg } from "src/Assets/icons/reservation.svg";
import { ReactComponent as SettingsSvg } from "src/Assets/icons/settings.svg";
//import { ReactComponent as SupportSvg } from "src/Assets/icons/support.svg";
import { ReactComponent as RoomsSvg } from "src/Assets/icons/rooms.svg";
import { ReactComponent as RateSvg } from "src/Assets/icons/rate.svg";
import { ReactComponent as ServicesSvg } from "src/Assets/icons/services.svg";
import { ReactComponent as ImgSvg } from "src/Assets/icons/slider.svg";
import { ReactComponent as PricingSvg } from "src/Assets/icons/pricing.svg";
import { ReactComponent as FloSvg } from "src/Assets/icons/flo.svg";

import notificationSoundFile from '../../Assets/sounds/dorbell.wav';
import Logo from "src/Assets/images/logo.png";
import { NavLink } from "react-router-dom";
import { useState,useEffect, useRef } from "react";
import API from 'src/API2';




import { useNotificationContext } from "../../NotificationContext";


const Sidebar = () => {
  const { notifications, setNotifications } = useNotificationContext();

  const soundRef = useRef(new Audio(notificationSoundFile));


  useEffect(() => {
    let lastNotificationId = null;

    const fetchNotifications = async () => {
      try {
        const response = await API.get("/notifications");
        const fiveDaysAgo = new Date();
        fiveDaysAgo.setDate(fiveDaysAgo.getDate() - 5);

        const recentNotifications = response.data.notifications
          .filter((notification) => new Date(notification.createdAt) >= fiveDaysAgo)
          .slice(0, 20);

        // Check if the latest notification is new
        if (recentNotifications[0]?.id !== lastNotificationId) {
          if (recentNotifications.length > 0 && recentNotifications[0]?.id) {
            soundRef.current.play();
            lastNotificationId = recentNotifications[0].id;
          }
        }

        setNotifications(recentNotifications); // Update shared state
      } catch (error) {
        console.error("Error fetching notifications:", error);
      }
    };

    fetchNotifications();

    const interval = setInterval(fetchNotifications, 12000);

    return () => clearInterval(interval);
  }, [setNotifications]);


  const staffName =
    localStorage.getItem("staffFullName") ||
    localStorage.getItem("fullname") ||
    "Staff member";
  const staffRole = localStorage.getItem("staffRole") || "Hotel team";
  const initials = staffName
    .split(" ")
    .map((s) => s[0])
    .filter(Boolean)
    .slice(0, 2)
    .join("")
    .toUpperCase();

  const unreadCount = (notifications || []).filter((n) => !n.isRead).length;

  const renderLink = (to, Icon, label, opts = {}) => (
    <NavLink
      to={to}
      end={opts.end}
      className={({ isActive }) => `sb-item ${isActive ? "is-active" : ""}`}
    >
      <span className="sb-item__icon"><Icon /></span>
      <span className="sb-item__label">{label}</span>
      {opts.badge ? <span className="sb-item__badge">{opts.badge}</span> : null}
    </NavLink>
  );

  return (
    <aside className="sb">
      {/* Brand */}
      <div className="sb-brand">
        <div className="sb-brand__logo">
          <img src={Logo} alt="Hotel logo" />
        </div>
        <div className="sb-brand__text">
          <span className="sb-brand__title">Protour</span>
          <span className="sb-brand__sub">Staff portal</span>
        </div>
      </div>

      <nav className="sb-nav">
        {/* Operations */}
        <div className="sb-group">
          <span className="sb-group__label">Operations</span>
          {renderLink("/", DashboardSvg, "Dashboard", { end: true, badge: unreadCount > 0 ? unreadCount : null })}
          {renderLink("calendar", PricingSvg, "Calendar")}
          {renderLink("reservations", ReservationSvg, "Reservations")}
        </div>

        {/* Property */}
        <div className="sb-group">
          <span className="sb-group__label">Property</span>
          {renderLink("rooms", RoomsSvg, "Room types")}
          {renderLink("roomItem", RoomsSvg, "Rooms")}
          {renderLink("floors", FloSvg, "Floors")}
          {renderLink("rates", RateSvg, "Rates")}
          {renderLink("services", ServicesSvg, "Services")}
          {renderLink("content", ImgSvg, "Content")}
        </div>

        {/* Account */}
        <div className="sb-group">
          <span className="sb-group__label">Account</span>
          {renderLink("settings", SettingsSvg, "Settings")}
        </div>
      </nav>

      {/* User card + Logout */}
      <div className="sb-foot">
        <div className="sb-user">
          <div className="sb-user__avatar" aria-hidden="true">{initials || "?"}</div>
          <div className="sb-user__info">
            <span className="sb-user__name">{staffName}</span>
            <span className="sb-user__role">{staffRole}</span>
          </div>
        </div>
        <button
          type="button"
          className="sb-logout"
          onClick={() => {
            localStorage.removeItem("accesstokenhotelparkmall");
            window.location = "/login";
          }}
        >
          <LogoutSvg />
          <span>Logout</span>
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
